import { combineReducers } from "redux";
import basicRequest from "../../../../core/redux/reducers/request";
import basicList from "../../../../core/redux/reducers/list";

const show = basicRequest("MANAGER_PAYMENT_SHOW");
const list = basicList("MANAGER_PAYMENT_LIST");

export default combineReducers({ list, show });
